import {Injectable} from '@angular/core';
import {BaseEndpointService} from '../base-endpoint-service';
import {Backend} from '@generated-backend-types';
import TeamMember = Backend.App.Resources.Dashboard.Administration.TeamMember;
import Publication = Backend.App.Resources.Dashboard.Administration.Publication;
import {ListItem} from '../../../entities/list-item.entity';

@Injectable({providedIn: 'root'})
export class AddableTeamMembersService extends BaseEndpointService<TeamMember> {
  public forPublication(p: Publication) {
    this.endpoint = `/administration/publications/${p.id}/addable-team-members`;
  }

  public override modelToMultiSelectItem(m: TeamMember): ListItem & { model: TeamMember; } {
    return {
      id: m.id,
      text: m.first_name + ' ' + m.last_name,
      isDisabled: false,
      model: m,
    }
  }
}
